// extracted by mini-css-extract-plugin
module.exports = {"documentPreview":"styles_documentPreview__W6ZvW","documentPreviewInner":"styles_documentPreviewInner__3zccb","missing":"styles_missing__BQWir"};